import axios, { AxiosRequestConfig } from "axios";
import { SecurityService } from "@/services/SecurityService";
import { msalService } from "./../auth/msalService";
import store from "@/store/index";

const axiosConfig = {
  baseURL: process.env.VUE_APP_AZNCONNECT_API_ROOT,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
    Accept: "application/json",
  },
};

const _axios = axios.create(axiosConfig);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  },
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    // Do something with response error
    return Promise.reject(error);
  },
);

_axios.interceptors.request.use(
  (config: AxiosRequestConfig): AxiosRequestConfig => {
    if (SecurityService.getInstance().isLoggedOn()) {
      config.headers.ZorgIDAuthorization =
        SecurityService.getInstance().zorgIDAuthorizationScheme +
        " " +
        SecurityService.getInstance().sessionId;
    } else {
      config.headers.ZorgIDAuthorization = null;
    }

    return config;
  },
  error => Promise.reject(error),
);

_axios.interceptors.request.use(
  async (config: AxiosRequestConfig) => {
    if (
      store.getters.authenticationConfiguration.authenticationType === "msal"
    ) {
      const token = await msalService.getToken();

      if (token) {
        config.headers = config.headers || {};
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    }

    return config;
  },
  error => Promise.reject(error),
);

export const AZNCONNECT_API = _axios;
